<template>
  <v-row dense>
    <v-col class="pt-0">
      <ReportHeading
        label="Пакети до подовження v2"
        :loading="loading"
        @update-report="updateReport"
      >
        <template v-slot:action>
          <DownloadFile
            location="xlsx"
            :params="reportData"
            filename="Пакети до подовження"
            extension="xlsx"
            tooltip="Завантажити у форматі Excel"
          />
          <v-switch
            v-model="onlyRecommended"
            :disabled="loading"
            color="green"
            label="Тільки рекомендовані пакети"
            dense
            class="mt-1"
          />
        </template>
        <template v-slot:filters>
          <v-row dense class="pb-3">
            <v-col class="py-0">
              <DatePicker
                v-model="date"
                label="На дату (включно)"
                :filled="false"
                @input="updateReport"
              />
            </v-col>

            <v-col class="py-0">
              <ManagerSelect
                v-model="manager"
                @input="updateReport"
              />
            </v-col>
            <v-col class="py-0">
              <v-autocomplete
                v-model="client"
                :items.sync="clients"
                :disabled="loading"
                :search-input.sync="search"
                clearable
                no-filter
                hide-no-data
                hide-selected
                hide-details
                dense
                label="Ім'я клієнта"
                placeholder="Введіть iм'я клієнта"
                class="mr-1 dense"
                outlined
                return-object
                item-text="title"
                item-value="id"
                append-icon="search"
                @click:append="clientId && (openModal = true)"
              />
              <ModalWindow
                :id="clientId"
                v-model="openModal"
                component-name="Client"
              />
            </v-col>
          </v-row>
        </template>
      </ReportHeading>

      <Totals
        :total-current-balance-hours="totalCurrentBalanceHours"
        :total-recommended-hours="totalRecommendedHours"
        :total-payment-amount="totalPaymentAmount"
      />

      <SimpleTable
        :headers="headers"
        :loading="loading"
        :items-per-page="filteredItems.length"
        :items="filteredItems"
      />
    </v-col>
  </v-row>
</template>
<script>
import ManagerSelect from "@/views/catalogs/managers/ManagerSelect.vue";
import DatePicker from "@/components/story/DatePicker.vue";
import Totals from "./Totals.vue";
import DownloadFile from "@/components/DowloadFile.vue";
import SimpleTable from "@/components/story/SimpleTable";
import * as reportsApi from "@/backend/reportsApi.js";
import headers from "./headers.js";
import ReportHeading from "@/components/ReportHeading.vue";
import { columnTypes, numberToString } from "@/helpers";

export default {
  components: {
    ManagerSelect,
    DatePicker,
    Totals,
    DownloadFile,
    SimpleTable,
    ReportHeading,
    ModalWindow() {
      return import("@/components/ModalWindow.vue");
    },
  },
  data: () => ({
    onlyRecommended: false,
    loading: false,
    items: [],
    manager: null,
    dateMenu: false,
    date: "",
    client: null,
    openModal: false,
    search: null,
  }),
  computed: {
    headers() {
      return headers;
    },
    filteredItems() {
      if (this.client) {
        return this.items.filter((i) => i.client.id === this.client.id);
      }
      if (this.onlyRecommended) {
        return this.items.filter((i) => i.recommendedPackage !== null);
      }
      return this.items;
    },
    clients() {
      let items = this.items.map((i) => i.client);
      if (this.search){
        items = items.filter(i => i.title.toUpperCase().includes(this.search.toUpperCase()));
      }
      return items;
    },
    totalCurrentBalanceHours() {
      return this.items.reduce((sum, i) => sum + i.currentBalanceHours, 0);
    },
    totalRecommendedHours() {
      return this.items.reduce((sum, i) => sum + i.recommendedHours, 0);
    },
    totalPaymentAmount() {
      return this.items.reduce((sum, i) => sum + i.paymentAmount, 0);
    },
    reportData() {
      return {
        columns: this.headers.map((h) => h.text),
        rows: this.items.map((item) => {
          const prevPayments = item.prevPayments
            ? item.prevPayments.map((p) => {
              return `${p.date} | ${p.hours} ч.${
                p.package ? " | " + p.package.title : ""
              }`;
            })
            : [];

          return [
            item.client.title,
            prevPayments.join("\n"),
            numberToString(item.currentBalanceHours),
            numberToString(item.spentHours),
            numberToString(item.recommendedHours),
            numberToString(item.paymentAmount),
            item.recommendedPackage?.title || "",
            item.nextPaymentDate,
            item.manager?.title || "",
            item.lastInvoice ? `№ ${item.lastInvoice.number} від ${item.lastInvoice.date} | ${item.lastInvoice.packageAmount}` : "",
          ];
        }),
        columnTypes: [
          columnTypes.STRING,
          columnTypes.STRING,
          columnTypes.NUMBER,
          columnTypes.NUMBER,
          columnTypes.NUMBER,
          columnTypes.NUMBER,
          columnTypes.STRING,
          columnTypes.DATE,
          columnTypes.STRING,
          columnTypes.STRING,
        ],
      };
    },
    clientId(){
      return this.client?.id || null;
    },
  },
  created() {
    this.date = this.moment().subtract(1, "days").format("YYYY-MM-DD");
    this.updateReport();
  },
  methods: {
    async updateReport() {
      this.loading = true;

      const filterParams = {
        managerId: this.manager?.id,
        date: this.date,
      };

      try {
        this.items = await reportsApi.packagesUpdateReport(filterParams);
      } catch {
        this.$notifyWarning("В даних звіту помилки. Подивіться в Система/Стан БД");
      }

      this.loading = false;
    },
  },
};
</script>
